import { memo } from "react";
import { Popup } from "@/components/popups/Popup";
import "./ProfileOptions.scss";
import { IProfileOptions } from "@/common/buses/popups/popup-types";
import { MenuItem, IMenuItem } from "@/components/burger-menu/MenuItem";
import TrashIcon from "@/common/images/icons/trashCanIcon.svg?react";
import EditIcon from "@/common/images/icons/edit_icon.svg?react";
import ShareIcon from "@/common/images/icons/share_icon.svg?react";
import DashboardIcon from "@/common/images/icons/dashboard.svg?react";
import ManageIcon from "@/common/images/icons/manage_icon.svg?react";
import { onCloseProfileOptions, onOpenDeleteAccount } from "@/components/popup-dispatcher/PopupDispatcher";
import { useUserStore } from "@/common/store";
import { routes } from "@/common/utils/routes";
import { copyUserLink } from "@/common/utils/share";

export const ProfileOptions = memo(({ username }: IProfileOptions) => {
  const currentUser = useUserStore((state) => state.currentUser);
  const isMyself = !!currentUser && currentUser.username === username;

  const options = [
    ...(isMyself ? [{
      icon: TrashIcon,
      className: "deleteAccount",
      title: "Delete this account",
      onClick: () => {
        onCloseProfileOptions();
        onOpenDeleteAccount();
      },
    }] : []),
    ...(isMyself ? [{
      icon: EditIcon,
      title: "Edit",
      link: routes.accountSettings(),
      onClick: () => {
        onCloseProfileOptions();
      }
    }] : []),
    {
      icon: ShareIcon,
      title: "Share this profile",
      onClick: async () => {
        if (username) {
          await copyUserLink(username);
        }

        onCloseProfileOptions();
      },
    },
    ...(isMyself ? [{
      icon: DashboardIcon,
      title: "Data Dashboard",
      link: routes.dashboard(),
      onClick: () => {
        onCloseProfileOptions();
      }
    }] : []),
    ...(isMyself ? [{
      icon: ManageIcon,
      title: "Manage Uploads",
      link: routes.manageProfile(),
      onClick: () => {
        onCloseProfileOptions();
      }
    }] : []),
  ];

  return (
    <Popup
      isOpen={true}
      popupClass="ProfileOptions"
      onClose={onCloseProfileOptions}
    >
      <ul className="profileOptionsList">
        {options.map((option: IMenuItem, index: number) => (
          <li key={index} className={option.className}>
            <MenuItem
              link={option.link}
              title={option.title}
              onClick={option.onClick}
              icon={option.icon}
            />
          </li>
        ))}
      </ul>
    </Popup>
  );
});
